import React from "react";
import { Box, Heading, Link, List, ListItem, Text, VStack } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

function scrollToBlogSection(e) {
  e.preventDefault();
  const el = document.getElementById("blog-section");
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
    window.history.replaceState(null, '', '#blog-section');
  } else {
    window.location.href = "/blog#blog-section";
  }
}

export default function HowToSpotAndAvoidLoanScams() {
  return (
    <Box maxW="1000px" mx="auto" px={{ base: 4, md: 8 }} py={{ base: 20, md: 32 }}>
      <VStack spacing={6} align="start">
        <Link
          as="button"
          onClick={scrollToBlogSection}
          aria-label="Back to Blog"
          position="fixed"
          top={{ base: "84px", md: "96px" }}
          left={{ base: 4, md: 8 }}
          zIndex="sticky"
          bg="white"
          color="teal.600"
          fontWeight="semibold"
          border="1px solid"
          borderColor="teal.100"
          borderRadius="full"
          px={{ base: 0, sm: 4 }}
          py={{ base: 0, sm: 2 }}
          w={{ base: "42px", sm: "auto" }}
          h={{ base: "42px", sm: "auto" }}
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="sm"
          _hover={{ textDecoration: "none", bg: "teal.50" }}
        >
          <Text as="span" display={{ base: "inline", sm: "none" }}>←</Text>
          <Text as="span" display={{ base: "none", sm: "inline" }}>← Back to Blog</Text>
        </Link>

        <Heading as="h1" size="xl" mb={2} mt={16}>How to Spot and Avoid Loan Scams</Heading>
        <Text fontSize="sm" color="gray.500">
          By Heavenly • March 09, 2026 • 5 mins read
        </Text>

        <Text>
          Online lending is convenient, but scams have become more sophisticated. Fraudsters copy real lender
          branding, create fake portals, and pressure people into fast decisions.
        </Text>

        <Heading as="h2" size="md">Why Loan Scams Work</Heading>
        <List spacing={2} pl={4} styleType="disc">
          <ListItem>Urgency: "Act now or lose approval"</ListItem>
          <ListItem>Confusion: unclear fee language and fake legal terms</ListItem>
          <ListItem>Trust abuse: cloned websites and spoofed email addresses</ListItem>
        </List>

        <Heading as="h2" size="md">Top Red Flags</Heading>
        <List spacing={2} pl={4} styleType="disc">
          <ListItem>Guaranteed approval with no review at all</ListItem>
          <ListItem>Request to pay an upfront fee before funding</ListItem>
          <ListItem>Pressure to share online banking password or card PIN</ListItem>
          <ListItem>Communication only via private chat apps</ListItem>
          <ListItem>Website with broken pages, spelling errors, or mismatched URLs</ListItem>
          <ListItem>No clear physical address or support contact</ListItem>
        </List>

        <Heading as="h2" size="md">How to Verify a Lender</Heading>
        <List spacing={2} pl={4} styleType="disc">
          <ListItem>Check the official website URL carefully</ListItem>
          <ListItem>Read disclosure details before providing personal data</ListItem>
          <ListItem>Confirm support email and phone via trusted channels</ListItem>
          <ListItem>Review fee, APR, and repayment terms in writing</ListItem>
          <ListItem>Pause if anything is vague or inconsistent</ListItem>
        </List>

        <Heading as="h2" size="md">Safe Borrowing Habits</Heading>
        <Text>
          Compare at least two offers, borrow only what you need, and never transfer money to "unlock" a loan.
          Legitimate lenders disclose costs before acceptance.
        </Text>

        <Heading as="h2" size="md">If You Suspect a Scam</Heading>
        <List spacing={2} pl={4} styleType="disc">
          <ListItem>Stop communication immediately</ListItem>
          <ListItem>Do not send additional documents or payments</ListItem>
          <ListItem>Change compromised passwords and enable 2FA</ListItem>
          <ListItem>Report suspicious activity to relevant authorities and your bank</ListItem>
        </List>

        <Heading as="h2" size="md">Final Thoughts</Heading>
        <Text>
          A legitimate loan process is transparent, documented, and secure. When in doubt, pause, verify, and choose
          the option that explains all costs clearly.
        </Text>
        <Box mt={10} width="100%" textAlign="center">
          <Heading as="h3" size="md" mb={3} color="teal.700">Get an instant loan now with Swift Credit</Heading>
          <Link as={RouterLink} to="/apply" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
            <Box as="button" bg="teal.500" color="white" px={8} py={3} borderRadius="md" fontWeight="bold" _hover={{ bg: "teal.600" }}>
              Get a Loan
            </Box>
          </Link>
        </Box>
      </VStack>
    </Box>
  );
}
